module.exports = __webpack_public_path__ + "img/arrow.e52491b4.png";